/* RCL v4: small progressive enhancements */
(function () {
  /* carousel progress line: expose scroll progress as --v4-p (0..1) */
  function bind(list) {
    var scroller = list.querySelector('slideshow-slides');
    if (!scroller || scroller.dataset.v4Bound) return;
    scroller.dataset.v4Bound = '1';
    var raf = 0;
    var update = function () {
      raf = 0;
      var max = scroller.scrollWidth - scroller.clientWidth;
      list.style.setProperty('--v4-p', max > 0 ? Math.min(1, Math.max(0, scroller.scrollLeft / max)).toFixed(4) : '1');
    };
    scroller.addEventListener(
      'scroll',
      function () {
        if (!raf) raf = requestAnimationFrame(update);
      },
      { passive: true }
    );
    window.addEventListener('resize', update);
    update();
  }

  function init() {
    document.querySelectorAll('.resource-list.force-full-width.resource-list__carousel').forEach(bind);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
